import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["option", "form"]
  static values = { kind: String }

  selectSwitchOption(event) {
    const button = event.currentTarget
    button.classList.toggle("on")
    let kind = button.querySelector(".checkbox")?.getAttribute("data-kind")
    let element = document.getElementById(kind)

    let new_value = "1"
    if (element.value == "1") {
      new_value = "0"
    }
    element.value = new_value

    if (kind === "user_communication_biometrics_lock_enabled") {
      window.dispatchEvent(new CustomEvent("biometrics-lock:toggle", { detail: { enabled: new_value === "1" } }))
    }

    this.formTarget.submit()
  }

  submit() {
    this.formTarget.submit()
  }
}
